export default {
  itemList: [],
  itemDetailList: [],
  userList: [],
  payment: {},
  userDetail: {},
  itemForPayment: {}
}
